import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { ReactNode, useState } from "react";

type CompletionCountProps = {
  answered: number;
  total: number;
};

type SubSectionCardProps = {
  title: string;
  answered: number;
  total: number;
  hasErrors: boolean;
  children: ReactNode;
};

const CARD_ITEM = "card";
const OPEN_ITEMS = [CARD_ITEM];
const CLOSED_ITEMS: string[] = [];

const CompletionCount = ({ answered, total }: CompletionCountProps) => (
  <Tag
    tagType={answered === total ? "green" : "orange"}
    icon={false}
    size="small"
    rounded
  >
    {answered}/{total}
  </Tag>
);

export const SubSectionCard = ({
  title,
  answered,
  total,
  hasErrors,
  children,
}: SubSectionCardProps) => {
  const [isOpen, setIsOpen] = useState(true);

  // a card holding a validation error stays open so the error is visible
  const isExpanded = isOpen || hasErrors;
  const openItems = isExpanded ? OPEN_ITEMS : CLOSED_ITEMS;

  const handleValueChange = (items: string[]) =>
    setIsOpen(items.includes(CARD_ITEM));

  return (
    <div className="t-mb-4">
      <Accordion.Root
        type="multiple"
        value={openItems}
        onValueChange={handleValueChange}
      >
        <Accordion.Item value={CARD_ITEM}>
          <Accordion.Trigger className="!t-normal-case">
            <span className="t-flex t-items-center t-gap-2 t-text-subtext t-text-text-100">
              {title}
              <CompletionCount answered={answered} total={total} />
            </span>
          </Accordion.Trigger>
          {/* fields stay mounted while collapsed so required field validation still finds them */}
          <Accordion.Content
            forceMount
            className={
              isExpanded
                ? "!t-px-2 !t-pt-0 [&_.dangerLabel]:!t-text-text-60"
                : "t-hidden"
            }
          >
            {children}
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </div>
  );
};
